import {TimeSpan} from "@sparkware/app-utils";
import {Id} from "react-toastify";
import {IdleRecommendationsComponentProps} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/idle-recommendations.component-props";
import {IStandardToastContentProps} from "../../components/toaster/toasts-content/standard-toast.component";

export interface IToastHandler {
    readonly toastId: Id;
    close(closeReason?: ToastCloseReason | string): void;
}

interface IToastOptions {
    timeout?: TimeSpan;
    hideProgressBar?: boolean;
    className?: string;
    closeButton?: boolean;
}

export const DEFAULT_TOAST_IMAGE = "DEFAULT_TOAST_IMAGE";

export enum ToastCloseReason {
    CloseButton = "CloseButton",
}

export interface IToastDefinition {
    id?: number | string;
    toastOptions?: IToastOptions;
    renderContent: (handler: IToastHandler) => React.ReactElement;
    onToastShown?: () => void;
    /**
     * @param closeReason ToastCloseReason | string | undefined
     * closeReason will be ToastCloseReason.CloseButton if the toast is closed from X button or undefined if it's autoClosed by the timeout or whatever you pass to the handler close method
     * Keep in mind that if you don't pass an argument to the close method the reason will be undefined just as in the case of timeout
     */
    onToastClosed?: (closeReason?: ToastCloseReason | string) => void;
}

export interface IStandardToastDefinition extends Omit<IToastDefinition, "renderContent"> {
    contentProps: IStandardToastContentProps;
}

interface IAnalyticsData {
    category: string;
    action: string;
    label?: string;
}

export interface IAnalyticsOptions {
    analyticsData?: IAnalyticsData;
}

/**
 * TODO: When idle_recommendations_service.ts will be moved in orbit services move this method to the new service. It belongs there
 */
export interface IIdleRecomToastDef extends Omit<IToastDefinition, "renderContent"> {
    contentProps: IdleRecommendationsComponentProps;
}

export interface IToasterService {
    readonly hasOpenToasters: boolean;
    showCustomToast(toastDef: IToastDefinition): IToastHandler;// Promise<IToasterHandler>;
    showStandardToast(toastDef: IStandardToastDefinition): IToastHandler;
    showAckStandardToast(toastDef: IStandardToastDefinition): IToastHandler;
    /**
     * TODO: When idle_recommendations_service.ts will be moved in orbit services move this method to the new service. It belongs there
     */
    showIdleRecommendationToast(toastConfig: IIdleRecomToastDef): IToastHandler;
}
